import { createPrinter } from "./escposFormatter";

// 32 chars for 58mm paper, 48 for 80mm — change per printer/config.
const Printer = createPrinter(32);

export function buildReceipt(order, brandData) {
  let r = "";
  r += Printer.initialize();

  /*
   * COMPANY LOGO
   * (placeholder text for now — see Printer.image() to print an
   * actual raster logo instead)
   */
  r += Printer.center();
  r += Printer.line(brandData.brandName);
  r += "\n";

  /*
   * TABLE NUMBER
   */
  r += Printer.boldOn();
  r += Printer.doubleSize();
  r += Printer.line(order.tableNumber);
  r += Printer.normalSize();

  /*
   * PAYMENT STATUS
   */
  r += Printer.center();
  r += Printer.boldOn();
  r += Printer.doubleSize();
  r += Printer.line(order.isPayLater ? "*** UNPAID ***" : "*** PAID ***");
  r += Printer.normalSize();
  r += Printer.boldOff();
  r += Printer.divider();

  /*
   * SPEND MODE
   */
  r += Printer.line(order.spendMode);
  r += Printer.boldOff();
  r += "\n";

  /*
   * TABLE NAME
   */
  r += Printer.boldOn();
  r += Printer.line(order.tableName);
  r += Printer.boldOff();
  r += Printer.divider();

  /*
   * ORDER DETAILS
   */
  r += Printer.left();

  if (order.waiterName) {
    r += Printer.row("Waiter", order.waiterName);
  }

  r += Printer.divider();

  /*
   * ITEMS
   */
  r += Printer.left();
  order.items.forEach((item) => {
    r += Printer.wrap(item.name);
    r += Printer.row(
      `${item.quantity} x ${Printer.money(item.unitPrice)}`,
      Printer.money(item.totalItemPrice),
    );
    r += "\n";
  });
  r += Printer.divider();

  /*
   * TOTAL
   */
  r += Printer.boldOn();
  r += Printer.row("TOTAL", Printer.money(order.amount));
  r += Printer.boldOff();
  r += Printer.divider();

  /*
   * FOOTER
   */
  r += "\n";
  r += Printer.center();
  r += Printer.line("Powered by");
  r += "\n";
  r += Printer.boldOn();
  r += Printer.line("Meeza");
  r += Printer.line("Meeza - The Doings App");
  r += Printer.boldOff();
  r += Printer.feed(3);
  r += Printer.cut();

  return r;
}

/**
 * When sending to the actual device, encode the string with a byte-safe
 * codec rather than plain UTF-8. ESC/POS printers read raw single-byte
 * code pages, so `Buffer.from(receiptText, "utf8")` will corrupt any
 * character outside ASCII. Example using iconv-lite:
 *
 *   import iconv from "iconv-lite";
 *   const bytes = iconv.encode(buildReceipt(order), "cp437");
 *   device.write(bytes);
 *
 * Since this formatter now uses "N" instead of "₦" for currency, ASCII-only
 * output is guaranteed here — but keep this in mind if you add any other
 * non-ASCII text (accented names, other currency symbols, etc.) later.
 */
